export class ResOrderDetails {
    OrderDetailCode : string;
    OrderCode : string;
    ProductName : string;
    ProductCode : string;
    ProductBarCode : string;
    UnitCode : string;
    UOMName : string;
    Ingredients: string;
    AddOnGroupCode : string;
    AddOnParentOrderDetailCode : string;
    ProductNote: string;
    SerialNumber : number;
    ProductType : number;
    AddOnGroupDetailCode: string;
    UnitType : number;
    UnitName: string;
    Quantity : number;
    UnitFragment : number;
    Price : number;
    DiscountRate : number;
    DiscountAmount : number;
    IsParentAddOn : boolean;
    IsUpdated: boolean;
    FlavorName: string;
    FlavorID: string;
    GrandAmount: number;
    PrinterName: string;
    Action: string;
}
